<template>
  <div class="container mx-auto">
    <div class="lg:relative">
      <div
        class="mx-auto max-w-7xl w-full pt-10 pb-20 text-center lg:py-20 lg:text-left"
      >
        <div class="px-4 lg:w-3/5 sm:px-8 xl:pr-16">
          <h1
            class="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl"
          >
            <span class="block xl:inline text-pplightbtnfont">PM360</span><br />
            <span class="block text-gray-500 xl:inline"></span>
          </h1>
          <p
            class="mt-3 max-w-md mx-auto text-lg md:leading-8 md:tracking-wider text-gray-500 sm:text-xl md:mt-5 md:max-w-2xl"
          >
            PM360 helps property professionals and tenants access the expert and
            accessible solutions that they need. &#127968;
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  name: "IndexPage",
};
</script>
